import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["beacon"]
  static values = {
    url: String,
    interval: { type: Number, default: 30000 },
    // When true, stop polling once the optional beacon target disappears.
    // Needed for turbo-frames that keep outer data-controller attrs while
    // swapping inner HTML (e.g. embeddings reindex progress → complete).
    requireBeacon: { type: Boolean, default: false }
  }

  connect() {
    if (this.shouldStop()) return

    this.startPolling()
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this)
    document.addEventListener("visibilitychange", this.handleVisibilityChange)
  }

  disconnect() {
    this.stopPolling()
    document.removeEventListener("visibilitychange", this.handleVisibilityChange)
  }

  handleVisibilityChange() {
    if (document.hidden) {
      this.stopPolling()
    } else if (!this.shouldStop()) {
      this.poll()
      this.startPolling()
    }
  }

  startPolling() {
    this.stopPolling()
    this.timer = setInterval(() => this.poll(), this.intervalValue)
  }

  stopPolling() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  shouldStop() {
    return this.requireBeaconValue && !this.hasBeaconTarget
  }

  poll() {
    if (this.shouldStop()) {
      this.stopPolling()
      this.element.removeAttribute("src")
      return
    }

    if (!this.element.hasAttribute("src")) {
      this.element.setAttribute("src", this.urlValue)
    } else {
      this.element.reload()
    }
  }

  highlightNewCompletions(event) {
    const oldCompleted = new Set(
      [...this.element.querySelectorAll(".step-complete[data-task-id]")]
        .map(el => el.dataset.taskId)
    )

    const newFrame = event.detail.newFrame
    newFrame.querySelectorAll(".step-complete[data-task-id]").forEach(el => {
      if (!oldCompleted.has(el.dataset.taskId)) {
        el.classList.add("step-just-completed")
      }
    })
  }
}
